export class Routes {
  static Home = '/';
  static Imprint = '/imprint';
  static Accessibility = '/accessibility';
  static Gdpr = '/privacy';
  static Helpdesk = '/helpdesk';
  static ParameterMgmt = '/parameters';
  static ParameterRead = '/parameters/:parameterId';
  static ParameterNew = '/parameters/new';
  static ParameterEdit = '/parameters/:parameterId/edit';
  static ParameterReject = '/parameters/:parameterId/reject';
  static ComponentMgmt = '/components';
  static ComponentRead = '/components/:componentType/:componentId';
  static ComponentNew = '/components/new';
  static ComponentEdit = '/components/:componentType/:componentId/edit';
  static ComponentDelete = '/components/:componentType/:componentId/delete';
  static Uploads = '/uploads';

}
